import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

interface SocialLoginButtonProps {
  provider: 'google';
  onError?: (error: string) => void;
}

const SocialLoginButton: React.FC<SocialLoginButtonProps> = ({ provider, onError }) => {
  const [loading, setLoading] = useState(false);
  const { loginWithGoogle } = useAuth();

  const handleSocialLogin = async () => {
    setLoading(true);
    try {
      const success = await loginWithGoogle();
      if (!success) {
        onError?.('Googleログインに失敗しました');
      }
    } catch (error) {
      console.error('Google login error:', error);
      onError?.('Googleログインに失敗しました');
    } finally {
      setLoading(false);
    }
  };

  const getButtonProps = () => {
    return {
      text: 'Googleでログイン',
      color: '#4285f4',
      icon: '🔍'
    };
  };

  const buttonProps = getButtonProps();

  return (
    <Button
      fullWidth
      variant="outlined"
      onClick={handleSocialLogin}
      disabled={loading}
      sx={{
        borderColor: buttonProps.color,
        color: buttonProps.color,
        '&:hover': {
          borderColor: buttonProps.color,
          backgroundColor: `${buttonProps.color}10`,
        },
        height: 48,
        fontSize: '0.9rem',
        textTransform: 'none',
      }}
      startIcon={
        loading ? (
          <CircularProgress size={20} />
        ) : (
          <span style={{ fontSize: '1.2rem' }}>{buttonProps.icon}</span>
        )
      }
    >
      {loading ? 'ログイン中...' : buttonProps.text}
    </Button>
  );
};

export default SocialLoginButton;